import CreateNewEmailCampaignAction from './CreateNewEmailCampaignAction.vue';
import EmailCampaignList from '@/components/EmailCampaign/EmailCampaignList/EmailCampaignList.vue';

export default {
  CreateNewEmailCampaignAction,
  EmailCampaignList,
};
